import React from 'react';
import './Button.css';

const Button = (props) => {
  return (
    <a href={props.href} className='button_link'>
      <button className='explore_button'>
        <span className="tab-left" />
        <h5>{props.text}</h5>
        <span className="tab-right" />
      </button>
    </a>
  );
};

export default Button;